import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';

export default class LineGraph extends React.Component {
	static propTypes = {
		data: PropTypes.object
	};
	render() {
		let { data, previousTotal, fillColour, totalTitle } = this.props.data;
		let labels = data[0][1].map((labelArray) => labelArray[0].replace(/^20([\d]{2})([\d]{2})([\d]{2})$/, '$3-$2-20$1'));

		let datasets = [];
		let totals = [];
		data.forEach((array) => {
			let returnObj = {};
			returnObj.label = array[0];
			returnObj.fill = !!fillColour;
			returnObj.cubicInterpolationMode = 'monotone';
			returnObj.data = array[1].map((value) => value[1]);
			returnObj.backgroundColor = fillColour || '#191919';
			returnObj.pointRadius = fillColour ? 0 : 3;
			returnObj.pointHitRadius = 4;
			returnObj.borderColor = fillColour || '#666';
			datasets.push(returnObj);
			totals.push(array[1].reduce((acc, value) => acc + value[1], 0));
		});

		let formattedData = {
			labels,
			datasets
		};

		let options = {
			responsive: true,
			legend: {
				display: false
			},
			spanGaps: true,
			gridLines: {
				display: false,
				zeroLineWidth: 0
			},
			scales: {
				xAxes: [
					{
						display: false
					}
				],
				yAxes: [
					{
						gridLines: {
							drawBorder: false
						},
						ticks: {
							precision: 0
						}
					}
				]
			},
			layout: {
				padding: {
					top: 10,
					bottom: 10,
					right: 10
				}
			}
		};

		const percentage = totals.length === 1 ? (100 * (totals[0] - previousTotal)) / totals[0] : 0;

		return (
			<div className="linegraph-container">
				{totals.length === 1 && (
					<div className={`linegraph-total${totalTitle ? '-title' : ''}`}>
						{new Intl.NumberFormat().format(totals[0])} {totalTitle}
						{previousTotal ? (
							percentage > 0 ? (
								<div className="text">▲ up {Math.round(percentage)}% since previous period</div>
							) : (
								<div className="text negative">▼ down {Math.round(Math.abs(percentage))}% since previous period</div>
							)
						) : null}
					</div>
				)}

				<Line height={120} data={formattedData} options={options} />
			</div>
		);
	}
}
